<mat-vertical-stepper
    *ngxPermissionsOnly="['updateLockoutScreen']"
    class="redesign-create-wizard-stepper"
    linear
    #stepper
    (selectionChange)="onTabSelectionChange($event)"
>
    <!-- select create or upload step -->
    <mat-step [completed]="selectCreateOrUploadStep.isValid()" *letVar="0 as stepIndex">
        <ng-template matStepLabel>{{ steps[stepIndex].text }}</ng-template>
        <div class="step-content">
            <app-edit-lockout-screen #selectCreateOrUploadStep (upsertActionChange)="step1Value = $event"></app-edit-lockout-screen>
        </div>
        <button
            [disabled]="!selectCreateOrUploadStep.isValid()"
            class="next-btn mat-stroked-button mat-button-base"
            mat-stroked-button
            matStepperNext
        >
            Next
        </button>
    </mat-step>
    <!-- create or upload step -->
    <mat-step *letVar="1 as stepIndex">
        <ng-template matStepLabel>{{ steps[stepIndex].text }}</ng-template>
        <div class="step-content">
            <ng-container *ngIf="step1Value === dealerLockoutUpsertImageAction.UPLOAD; else createNewLockout">
                <p class="step-help-text">The uploaded image must be <span>1024px x 600px in PNG or JPG</span> format.</p>
                <p class="step-help-text">Once you've uploaded your file you will be able to download it to any device in the next step</p>
                <button mat-raised-button class="clare-button upload-btn" color="clare-primary" (click)="displaySaveImageDialog()">
                    Upload
                </button>
            </ng-container>
            <ng-template #createNewLockout>
                <app-dealer-branding-management #dealerBrandingCreate [pngKey]="pngKey" (emitImagePNG)="onSaveImagePNG($event)">
                </app-dealer-branding-management>
            </ng-template>
        </div>
        <button [disabled]="!isStep2Valid()" class="next-btn mat-stroked-button mat-button-base" mat-stroked-button (click)="onStep2Next()">
            Next
        </button>
    </mat-step>
    <!-- name and download step -->
    <mat-step *letVar="2 as stepIndex">
        <ng-template matStepLabel>{{ steps[stepIndex].text }}</ng-template>
        <div class="step-content">
            <form [formGroup]="lockoutNameForm">
                <p class="step-help-text">
                    Provide a unique name for this lockout to differentiate between additionally created lockout screens.
                </p>
                <mat-form-field appearance="outline" *letVar="lockoutNameForm.controls.name as field">
                    <mat-label i18n>Lockout Screen Name</mat-label>
                    <input
                        matInput
                        id="name"
                        type="text"
                        formControlName="name"
                        required
                        [errorStateMatcher]="errorMatcher"
                        maxlength="89"
                    />
                    <mat-hint i18n><span class="step-help-text input-help">Max 90 characters</span></mat-hint>
                    <mat-error>
                        <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                    </mat-error>
                </mat-form-field>
            </form>
            <hr class="create-lockout-divider" />
            <div class="download-container">
                <p class="step-help-text">Optional*</p>
                <p class="step-help-text">
                    Download this file to upload it via the Installer settings on security panels without network connections.
                </p>
                <button
                    [disabled]="!lockoutNameForm.valid"
                    class="mat-stroked-button mat-button-base download-btn"
                    mat-stroked-button
                    (click)="downloadLocalImage()"
                >
                    <mat-icon svgIcon="download_no_border"></mat-icon>Download Screen
                </button>
            </div>
        </div>
        <button
            [disabled]="!lockoutNameForm.valid"
            class="clare-button mat-raised-button mat-button-base mat-clare-primary"
            (click)="upsertNewImage()"
        >
            Done
        </button>
    </mat-step>
</mat-vertical-stepper>

<ng-template #clareRxDialog>
    <clare-dialog
        [icon]="configData.icon"
        [title]="configData.title"
        [message]="configData.message"
        [loadingMessage]="configData.loadingMessage"
        [isLoading]="configData.isLoading"
    >
        <ng-container additionalContent *ngIf="configData.messageHint">
            <p class="msg-hint" [innerHTML]="configData.messageHint"></p>
        </ng-container>
        <ng-container>
            <button mat-raised-button (click)="dialog.closeAll()">Close</button>
            <button mat-raised-button color="primary" *ngIf="configData.buttonText" (click)="configData.method()">
                {{ configData.buttonText }}
            </button>
        </ng-container>
    </clare-dialog>
</ng-template>
<div #clareRxDialogContainer></div>
